export default "__VITE_ASSET__0419ddc7__"